module.exports = __webpack_public_path__ + "static/img/26.2ee9bdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/26.png
// module id = a0+5
// module chunks = 0